import React from 'react';
import Logo from './Logo';

/* Small line icons for the marketing panel. */
function IconBolt() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M13 2 4 14h7l-1 8 9-12h-7Z" /></svg>
  );
}
function IconDrop() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3s-6 6.7-6 11a6 6 0 0 0 12 0c0-4.3-6-11-6-11Z" /></svg>
  );
}
function IconBell() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M6 8a6 6 0 1 1 12 0c0 5 2 6 2 6H4s2-1 2-6" /><path d="M9 18a3 3 0 0 0 6 0" /></svg>
  );
}

// Shared brand / value panel for the left side of the auth screens (login,
// password reset). Desktop-only — hidden below 1024px via global.css. Kept in
// one place so the login and reset pages stay visually identical.
export default function AuthArtPanel() {
  return (
    <div className="login-art">
      <div className="login-art-body">
        <h2>Know your water — anywhere.</h2>
        <p>Instantly check your water tank levels from your phone.</p>

        <ul className="login-points">
          <li>
            <span className="login-point-ico"><IconBolt /></span>
            <div>
              <div className="login-point-title">Simple to set up</div>
              <div className="login-point-desc">And even easier to use.</div>
            </div>
          </li>
          <li>
            <span className="login-point-ico"><IconDrop /></span>
            <div>
              <div className="login-point-title">Water levels at a glance</div>
              <div className="login-point-desc">Open the app to check the tank. No walking out, no guessing.</div>
            </div>
          </li>
          <li>
            <span className="login-point-ico"><IconBell /></span>
            <div>
              <div className="login-point-title">Low-water alerts &amp; leak detection</div>
              <div className="login-point-desc">Schedule deliveries with time to spare. Spot leaks before you run out.</div>
            </div>
          </li>
        </ul>
      </div>

      <div className="login-art-foot">Designed and built on the Big Island.</div>
      <div className="login-art-mark"><Logo variant="icon" width={480} /></div>
    </div>
  );
}
